import { locationPageCrumbs } from "../structured-data-core";
import { serviceAreaSchema } from "./service-area";

export function getSanDiegoStructuredData() {
  const url = "https://restorehair.com/locations/california/san-diego/";
  const description =
    "Find out about your hair transplant options in San Diego with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    serviceAreaSchema("san-diego", url, description),
    locationPageCrumbs(url, "San Diego"),
  ];
}
